/**
 * @prettier
 */
import { KEY_NAME } from 'src/localStorage/setPosInterfaceLargerEnabledRestaurantSettingInLocalStorage';

export function getPosInterfaceLargerEnabledRestaurantSettingInLocalStorage(): boolean {
    return window.localStorage.getItem(KEY_NAME) === 'true';
}
